module.exports = __webpack_public_path__ + "assets/images/Agenda/fiducial.111c1ba24920abb8bab7916ce2ef99fe.png";